module.exports = __webpack_public_path__ + "media/images/banner/klook/pc/rental-o_770_280_zh-hans-3199e02483fd0fb579e5796d18001989.jpg";